import React from "react";
import moment from "moment";
import find from "lodash/find";
import get from "lodash/get";
import upperFirst from "lodash/upperFirst";
import SingleEvent from "components/event/SingleEvent";
import { connect } from "react-redux";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import LoadingSpinner from "components/LoadingSpinner";
import Card from "@material-ui/core/Card";
import HiddenOn from "components/common/HiddenOn";

const UpcomingWeekendEvent = ({ events, day, error, loading }) => {
  const dayToNum = {
    sunday: "7",
    saturday: "6",
    friday: "5",
  };

  let nextEvent = getNextEvent({
    events: events,
    day: dayToNum[day],
  });

  if (!nextEvent) {
    nextEvent = {};
  }

  const {
    event_date,
    event_owner,
    event_repo,
    event_title,
    event_id,
  } = nextEvent;

  return (
    <StyledWrapper>
      <div>
        <Typography variant="h5" component="h3">
          Next {upperFirst(day)}'s Event
        </Typography>
        <HiddenOn hideOn={!loading}>
          <LoadingSpinner />
        </HiddenOn>
        <HiddenOn
          hideOn={error}
          fallback={"There was a problem, please try again later"}
        >
          <SingleEvent
            event_id={event_id}
            event_date={event_date}
            event_owner={event_owner}
            event_repo={event_repo}
            event_title={event_title}
          />
        </HiddenOn>
      </div>
    </StyledWrapper>
  );
};

function getNextEvent({ events, day }) {
  if (!events.length) {
    return;
  }
  let ret = new Date();
  ret.setDate(ret.getDate() + ((day - 1 - ret.getDay() + 7) % 7) + 1);
  const nextDate = moment(ret).format("LL");
  return find(events, (i) => moment(i.event_date).format("LL") === nextDate);
}

export const StyledWrapper = styled(Card)`
  width: 240px;
  height: 200px;
  text-align: center;
  background: #36393f !important;
  > div {
    background-color: #36393f;
    padding-top: 5px;
    height: 100%;
    width: 100%;
    color: #d3d3d4;
  }
  h3 {
    border-bottom: black 1px solid;
  }
`;

const mapStateToProps = (state) => ({
  events: get(state, "rootReducer.orbat.openEvents.events", []),
  error: get(state, "rootReducer.orbat.openEvents.error"),
  loading: get(state, "rootReducer.orbat.openEvents.loading"),
});

export default connect(mapStateToProps, null)(UpcomingWeekendEvent);
